ponents/echart/right/topLeft/chart.vue  0 → 100644
<template>
  <div>
    <!-- 巡回指导统计 -->
    <Echart :options="options" height="534px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        // console.log(newData,'newData');
        let color = ['#e8307a', '#25cff3', '#f3c824', '#e7421b'];

        let seriesArr = [];
        newData.yAxisData.map((item) => {
          let seriesItem = {
            barGap: '30%',
            name: item.seriesName,
            type: 'bar',
            barWidth: 10,
            data: item.seriesData
          };
          seriesArr.push(seriesItem);
        });
        this.options = {
          // 是否开启渲染动画
          color: color,
          calculable: true,
          // 距离dom四周的距离
          grid: {
            top: '25%',
            left: '10%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          // 图例组件，用来显示不同系列的标记
          legend: {
            data: newData.legends,
            top: '8%',
            itemGap: 30,
            itemWidth: 20, // 图例图形宽度
            itemHeight: 12, // 图例图形高度
            textStyle: {
              color: '#fff',
              fontSize: 12
            }
          },
          // 鼠标移上去显示悬浮信息
          tooltip: {
            show: true,
            trigger: 'axis',
            axisPointer: {
              type: 'shadow' // 默认为直线,可选为：'line' | 'shadow'
            }
          },
          // x轴坐标系
          xAxis: [
            {
              type: 'category', // 默认显示类目名
              boundaryGap: true, // 坐标轴两端是否留白
              nameTextStyle: {
                color: '#fff',
                fontSize: 14
              },
              // 坐标轴轴线相关设置
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#09507E',
                  width: 2
                }
              },
              // 坐标轴刻度标签相关设置
              axisLabel: {
                interval: 'auto',
                color: '#fff',
                padding: [5, 0, 0, 0],
                rotate: 0
              },
              // 坐标轴刻度相关设置
              axisTick: {
                show: false
              },
              data: newData.xAxisData
            }
          ],
          // y轴坐标系
          yAxis: {
            min: 0,
            minInterval: 0.5,

            axisTick: {
              //y轴刻度线
              show: false
            },
            axisLine: {
              //y轴
              show: false
            },
            splitLine: {
              // 网格线
              show: true,
              lineStyle: {
                //分割线
                color: '#2c4473',
                width: 1,
                type: 'dashed' //dotted：虚线 solid:实线
              }
            }
          },

          // 专门用来放数据和设置图表类型等属性
          series: seriesArr
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
